import { useLazyQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { ProductFilterInput } from '@/graphql/contracts/_generated_/contracts';
import { GetPaginatedFilteredProducts, GetPaginatedFilteredProductsVariables }
  from '@/graphql/contracts/_generated_/getPaginatedFilteredProducts.query';
import { notificationService } from '@/services/notification/notification.client';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';
import GetPaginatedProductsQuery from '@/graphql/contracts/getPaginatedFilteredProducts.query.gql';

export type PaginatedFilteredProducts = PaginatedFilteredGridData<ProductFilterInput>;

export default function useGetProducts() {
  const [_getProducts] = useLazyQuery<
  GetPaginatedFilteredProducts,
  GetPaginatedFilteredProductsVariables
  >(GetPaginatedProductsQuery, {
    client: apolloClientContracts,
    fetchPolicy: 'network-only',
    onError: (err) =>
      notificationService.open({
        title: 'Error',
        text: err.message,
        type: 'danger',
      }),
  });

  const getProducts = async (params: PaginatedFilteredProducts) => {
    const response = await _getProducts({
      variables: {
        ...params,
      } as GetPaginatedFilteredProductsVariables,
    });

    return response.data?.products;
  };

  return {
    getProducts,
  } as const;
}
